import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesJimeng31Params {
  /**
   * 提示词，必填，长度必须在1-800个字符之间
   */
  prompt: string;
  /**
   * 是否使用预处理LLM，默认值为true
   * @default true
   */
  use_pre_llm?: boolean;
  /**
   * 随机种子，-1或正整数，默认值为-1
   * @default -1
   */
  seed?: number;
  /**
   * 图像宽度，范围512-2048，必须与height同时提供
   */
  width?: number;
  /**
   * 图像高度，范围512-2048，必须与width同时提供
   */
  height?: number;
}

export interface VolcesJimeng31Resource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_jimeng_3_1
 *
 * Volces Jimeng 3.1 Image Generator implementation.
 * 
 * Model: 即梦3.1 (Jimeng 3.1)
 * Features: 文本生成图像功能
 * Prompt Length: 1-800字符
 * Image Dimensions: 512-2048像素（宽高必须同时提供）
 * Aspect Ratio: 1:3 到 3:1
 * Seed: -1(随机) 或正整数
 * Pre-LLM: 默认启用
 * 
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesJimeng31 } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesJimeng31({
 *   // 参数见 VolcesJimeng31Params 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesJimeng31Params 接口定义
 * @returns 生成的资源列表
 */
export async function volcesJimeng31(
  params: VolcesJimeng31Params,
): Promise<VolcesJimeng31Resource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_jimeng_3_1',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesJimeng31Resource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
